import React from "react";
import FlatButton from "./FlatButton";
import RaisedButton from "./RaisedButton";

function Dialog(props) {
  const { title, theme, action, children, visible, onAccept, onClose } = props;

  const classes = "DialogBackdrop" + (visible ? "" : " DialogHide");

  let headId = "Head";
  if (theme) {
    headId = `HeadTheme-${theme}`;
  }

  return (
    <div className={classes}>
      <div className="DialogPanel">
        <div id={headId}>
          {title}
          <i className="fas fa-times" onClick={() => onClose()} />
        </div>
        {children}
        <div id="Foot">
          <RaisedButton
            label={action}
            theme={theme}
            onClick={() => onAccept()}
          />
          <FlatButton label="Abbrechen" onClick={() => onClose()} />
        </div>
      </div>
    </div>
  );
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialog.js